
export const Routes = {
  Welcome: { path: '/' },
  Login: { path: '/login' },
  Register: { path: '/register' },
  Dashboard: { path: '/dashboard' },
  Decide: { path: '/decide' },
  Rules: { path: '/rules' },
  RuleDetail: { path: '/rules/:id' },
  Blocklist: { path: '/blocklist' },
  Tokens: { path: '/tokens' },
  Account: { path: '/account' },
  Developers: { path: '/developers' },
  AdminLogin: { path: '/admin/login' },
  AdminTenants: { path: '/admin/tenants' },
  AdminTenantDetail: { path: '/admin/tenants/:id' },
  AdminOperators: { path: '/admin/operators' },
  AdminAccount: { path: '/admin/account' },
  AdminAcceptInvite: { path: '/admin/accept-invite' },
  NotFound: { path: '/404' },
};
